import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { classes } from '@/helpers/styling';

const SortableItem = sortableElement(({ value, className }) => (
  <li className={ classes('sortable-list-item', className) }>
    { value }
  </li>
));

const SortableContainer = sortableContainer(({ children, className }) => (
  <ul className={ classes('sortable-list-container', className) }>
    { children }
  </ul>
));

const SortableList = ({
  listItems,
  sortableContainerProps,
  listClassName,
  listItemClassName,
  shouldCancelStart
}) => {
  const containerProps = {
    ...sortableContainerProps,
    helperClass: classes('sortable-helper', sortableContainerProps.helperClass)
  };

  const listItemsCount = listItems.length;

  const handleShouldCancelStart = useCallback(
    (e) => (
      (listItemsCount < 2)
      || (shouldCancelStart ? shouldCancelStart(e) : false)
    ),
    [shouldCancelStart, listItemsCount]
  );

  return (
    <div
      // id='queue-scrolling-parent' // This is used alongside the package patch to set the scrolling parent
      className='sortable-list-container-wrapper'
    >
      <SortableContainer
        className={ listClassName }
        shouldCancelStart={ handleShouldCancelStart }
        { ...containerProps }
      >
        { listItems.map(({ element, key }, index) => (
          <SortableItem
            className={ listItemClassName }
            index={ index }
            key={ key }
            value={ element }
          />
        )) }
      </SortableContainer>
    </div>
  );
};

SortableList.propTypes = {
  listItems: PropTypes.array.isRequired,
  sortableContainerProps: PropTypes.object,
  listClassName: PropTypes.string,
  listItemClassName: PropTypes.string,
  shouldCancelStart: PropTypes.func
};

SortableList.defaultProps = {
  sortableContainerProps: {},
  listClassName: '',
  listItemClassName: '',
  shouldCancelStart: undefined
};

export default SortableList;